import { createContext } from "@polifonia/utils/react/createContext";
import type { ReactNode } from "react";
import { type FC } from "react";

import { InfoBox } from "@/components/InfoBox";
import { BarLoading } from "@/components/Loading/BarLoading";
import { interlude, type InterludeTypes } from "@/interlude";

const unifyOrgsContext = createContext<Array<InterludeTypes["Org"]>>({
  name: "UnifyOrgsContext",
});

const Provider: FC<{ children: ReactNode }> = ({ children }) => {
  const unifyOrgsQuery = interlude.unifyScopeSetting.useGetOrganization();

  if (unifyOrgsQuery.isPending) return <BarLoading />;

  if (unifyOrgsQuery.isError)
    return (
      <InfoBox variant="error" description={unifyOrgsQuery.error.message} />
    );

  return (
    <unifyOrgsContext.Provider value={unifyOrgsQuery.data}>
      {children}
    </unifyOrgsContext.Provider>
  );
};

const plugin = {
  useUnifyOrgsContext: unifyOrgsContext.useContext,
};

const UnifyOrgsProvider = Object.assign(Provider, plugin);

export { UnifyOrgsProvider };
